<div *ngIf="mode === 'instagram'; else projectGalleryGrid" class="instagram-grid-wrap">
  <div class="instagram-grid grid grid-nogutter">
    <div *ngFor="let item of items; trackBy: trackByMediaItem" class="col-4 md:col-3 item item-padding">
      <div [attr.data-testid]="'instagram-item-' + item.instagramMediaId" class="instagram-tile" (click)="toggleSelectItem(item)">
        <p-checkbox
          styleClass="absolute top-0 left-0 instagram-checkbox"
          [ngModel]="item.selected"
          [disabled]="submitting"
          (click)="$event.stopPropagation()"
          (ngModelChange)="setSelectItem(item, $event)"
          [binary]="true"
        />
        <img
          alt="instagram thumbnail"
          *ngIf="getThumbnailSrc(item); else instagramNoPreview"
          class="media-thumbnail w-full h-full"
          [src]="getThumbnailSrc(item)"
        />
        <div *ngIf="isVideoItem(item)" class="instagram-tile__video-icon">
          <i class="pi pi-video text-4xl text-color-secondary"></i>
        </div>
        <div class="instagram-tile__meta" *ngIf="item.caption || item.publishedAt">
          <div class="instagram-tile__caption" *ngIf="item.caption">{{ item.caption }}</div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="submitting" class="instagram-grid-loader">
    <app-spinner [inline]="true" size="1.8rem"></app-spinner>
  </div>
</div>

<ng-template #instagramNoPreview>
  <div class="media-thumbnail w-full h-full surface-200 flex align-items-center justify-content-center">
    <i class="pi pi-image text-4xl text-color-secondary"></i>
  </div>
</ng-template>

<ng-template #projectGalleryGrid>
  <div #container class="media-choice-frame-grid-wrap">
    <app-frame-grid-layout
      *ngIf="items.length"
      [items]="items"
      [trackBy]="trackByMediaItem"
      [frame]="projectGalleryFrame"
      [gapPx]="4"
      [appendDisabled]="loadingMore || endOfResults"
      [appendTriggerMarginPx]="1200"
      (appendRequested)="requestNextPage()"
      class="media-choice-project-gallery-grid"
    >
      <ng-template let-item>
        <div class="project-gallery-tile item-padding">
          <ng-container *ngIf="isPlaceholderItem(item); else projectGalleryMediaTile">
            <p-skeleton class="project-gallery-tile__media" width="100%" height="100%"></p-skeleton>
          </ng-container>
          <ng-template #projectGalleryMediaTile>
            <div class="project-gallery-checkbox-wrap">
              <p-checkbox
                styleClass="project-gallery-checkbox"
                [ngModel]="item.selected"
                (ngModelChange)="toggleSelectItem(item)"
                [binary]="true"
              />
            </div>
            <img
              alt="media thumbnail"
              *ngIf="isImageItem(item)"
              class="project-gallery-tile__media media-thumbnail"
              [src]="getMediaObject(item) | mediaObject"
              (click)="toggleSelectItem(item)"
            />
            <video
              *ngIf="isVideoItem(item)"
              preload="metadata"
              class="project-gallery-tile__media media-thumbnail"
              crossorigin
              muted="muted"
              [src]="getMediaObject(item) | mediaObject:{formatType: 'original'}"
              [poster]="getMediaObject(item) | mediaObject:{formatType: 'm3u8_timeline'}"
              (click)="toggleSelectItem(item)"
            ></video>
          </ng-template>
        </div>
      </ng-template>
    </app-frame-grid-layout>
  </div>
</ng-template>
